module.exports = "<section class=\"hero\">\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/hero/hero.html
// module id = 368
// module chunks = 0